import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum OfferProgressId {
  NONE = 0,
  SENT = 1,
  FIRST_REMINDER = 2,
  SECOND_REMINDER = 3,
}

export class OfferProgress extends Codebook<OfferProgressId> {
  static readonly NONE = new OfferProgress(OfferProgressId.NONE, () => '')
  static readonly SENT = new OfferProgress(OfferProgressId.SENT, () => $t('Sent'))
  static readonly FIRST_REMINDER = new OfferProgress(OfferProgressId.FIRST_REMINDER, () =>
    $t('Reminder 1'),
  )
  static readonly SECOND_REMINDER = new OfferProgress(OfferProgressId.SECOND_REMINDER, () =>
    $t('Reminder 2'),
  )

  private constructor(
    id: OfferProgressId,
    public readonly name: () => string,
  ) {
    super(id)
  }

  public isAfter = (id: OfferProgressId): boolean => {
    return this.id <= id
  }

  static allViewable = (): OfferProgress[] => {
    return [OfferProgress.SENT, OfferProgress.FIRST_REMINDER, OfferProgress.SECOND_REMINDER]
  }
}
